




















import Vue from 'vue'

import { MenuMixin } from './MenuMixin'
import RowAddWidgetMenu from './RowAddWidgetMenu.vue'

export default Vue.extend({
  mixins: [MenuMixin],
  components: {
    RowAddWidgetMenu
  },
  methods: {
    addRowBefore() {
      this.$emit('row-add-new', true)
      this.hideDialog()
    },
    addRowAfter() {
      this.$emit('row-add-new', false)
      this.hideDialog()
    },
    onAddNewWidget(widgetType) {
      this.$emit('widget-add-new', widgetType)
      this.hideDialog()
    }
  }
})
